// extracted by mini-css-extract-plugin
export var iframe = "document-upload-module--iframe--wFvUe";